
const solventSolutionModeler = require('./SolventSolutionModeler');
const sum = require('./sum');

// A reasonable model for the heat capacity is
// Solids contribute their heat capacity (m*Cp)
// Liquids other than the solvent contribute their heat capacity (m*Cp)
// These two are labeled others
// Solvent and all aqueous species are approximated by the solvent heat capacity



class SpecificHeatSolutionMod {
	static getValue(sol) {
		let totalWeight = sol.getSolutionWeight();
		// List of objects containing the species and the SpeciesNode information
		let species = sol.getSpeciesData().map(
							(species, i) => {
								return {species:species, ...sol.getSpeciesAt(i)}
							}
						);

		let others = species
				.filter(x => x.species.id != 0 && x.species.state != 'aq');

		let otherWeight = sum(others.map(x => x.species.weight));
		
		let otherHeatCapacity = sum(others
			.map(x => x.species.weight * x.archetype.cp));

		let solventAqHeatCapacity = (totalWeight - otherWeight) * 
							solventSolutionModeler.getSolventSpecificHeat();

		return (otherHeatCapacity + solventAqHeatCapacity) / totalWeight;

    }
}

module.exports = SpecificHeatSolutionMod;